import { convertLayoutItem, convertShortInfoEntry } from './common';
import { convertGeoCoordinates } from './mapLocation';
import { convertSimplifiedProjectItemResponse } from './projectItem';
import { MapLocationInfoTypes, ProjectLayoutTypes, ProjectTypes } from '../../types';
import {
  MapLocationInfoResponseTypes,
  ProjectLayoutResponseTypes,
  ProjectResponseTypes,
} from '../../types/response';
import { checkValidUrl } from '../shareLinkUtils';

const convertProjectLocationResponse = (
  item: MapLocationInfoResponseTypes
): MapLocationInfoTypes => ({
  id: item.id,
  name: item.name,
  code: item.code,
  geoCoordinates: convertGeoCoordinates(item.geoCoordinates),
  geoType: item.geoType,
  fillColor: item.fillColor,
  fillOpacity: item.fillOpacity,
  strokeColor: item.strokeColor,
  strokeWeight: item.strokeWeight,
  location: item.location,
  type: item.type,
  description: item.description,
  gallery: item.gallery,
});

export const convertProjectLayoutResponse = (
  item: ProjectLayoutResponseTypes
): ProjectLayoutTypes => {
  const layout = convertLayoutItem(item);
  return {
    ...layout,
    id: `${item.projectId}_${item.itemId}`,
    projectId: item.projectId,
    projectItemId: item.itemId,
  };
};

export const convertProjectResponse = (item: ProjectResponseTypes): ProjectTypes => {
  const { shortInformation, introduction, information } = convertShortInfoEntry(item.shortInfo);
  const layoutItems = (item.layoutItems || []).map((l) => convertProjectLayoutResponse(l));
  const projectItems = (item.items || [])
    .concat(item.amenities || [])
    .map((i) => convertSimplifiedProjectItemResponse(i));
  const newsHaveTitle = (item.news || []).filter((element) => element.title);

  return {
    id: item.id,
    code: item.code,
    name: item.name,
    address: item.address,
    ignoreFeatures: [],
    userTokens: [],

    media: item.gallery,
    logo: item.logo,
    visualizeCode: item.visualizeCode,
    description: item.description,
    location: item.location ? convertProjectLocationResponse(item.location) : null,

    introduction,
    shortInformation,
    information,

    itemIds: projectItems.map((i) => i.id),
    layoutImage: item.imageLayout,
    layoutItemIds: layoutItems.map((l) => l.id),

    items: projectItems,
    layoutItems,
    alias: item.alias,
    bannerBgColor: item.bannerBgColor,
    bannerColor: item.bannerColor,
    bannerBg: item.bannerBg,
    bannerName: item.bannerName,
    bannerInfo: item.bannerInfo,
    news:
      newsHaveTitle &&
      newsHaveTitle.length &&
      newsHaveTitle.map((news) => ({ ...news, isSimplified: true })),
    newsIds: newsHaveTitle && newsHaveTitle.length && newsHaveTitle.map((news) => news.id),
    userContact: item.userContact,
    configs: item.configs,
    avgReviewRating: item.avgReviewRating,
    reviews: item.reviews,
    projectTourUrl: item.projectTourUrl,
    parentProject: item.parentProject,

    // cooperators
    cooperators: item.cooperators && item.cooperators.map((e) => ({ ...e, isSimplified: true })),
    starterModuleType: item.starterModuleType,
    inactivePointColor: item.inactivePointColor,
    publishedLanguages: item.publishedLanguages,
    language: item.language,
    sitePlanVT360Url: checkValidUrl(item.sitePlanVT360Url) ? item.sitePlanVT360Url : undefined,
    amenitiesVT360Url: checkValidUrl(item.amenitiesVT360Url) ? item.amenitiesVT360Url : undefined,
    layout360Items: item.layout360Items,
    layout360: item.layout360,
    pageLayouts: item.pageLayouts,

    // ai question
    hasAIQuestion: item.hasAIQuestion,
  };
};
